export const getCalculatorCents = function(approvedAmountCents, purchaseAmountCents) {
    approvedAmountCents = approvedAmountCents || 0
    purchaseAmountCents = purchaseAmountCents || approvedAmountCents
    return Math.min(approvedAmountCents, purchaseAmountCents)
}
